<!--  -->
<template>
  <div>
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="150px"
      class="demo-ruleForm"
    >
      <el-form-item
        label="活动名称"
        prop="title"
      >
        <el-input
          v-model="ruleForm.title"
          style="width:400px"
        />
      </el-form-item>
      <el-form-item
        label="充值金额"
        prop="recharge_money"
      >
        <el-input
          v-model="ruleForm.recharge_money"
          type="number"
          style="width:400px"
          placeholder="单位（元）"
          @blur="activemoney"
        />
      </el-form-item>
      <el-form-item label="金币数量">
        <el-input
          v-model="cionnum"
          disabled
          type="number"
          style="width:400px"
          placeholder="单位（个）"
          @blur="activegivemoney"
        />
      </el-form-item>
      <el-form-item
        label="赠送金币"
        prop="give_coin"
      >
        <el-input
          v-model="ruleForm.give_coin"
          type="number"
          style="width:400px"
          placeholder="单位（个）"
          @blur="givemoneyuwrw"
        />
      </el-form-item>
      <el-form-item
        label="充值次数"
        prop="recharge_times"
      >
        <el-select
          v-model="ruleForm.recharge_times"
          placeholder="请选择充值次数"
        >
          <el-option
            v-for="item in restrictions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="弹窗频率">
        <el-radio-group
          v-model="ruleForm.popup_rule"
          @change="popupser"
        >
          <el-radio :label="1">每天一次</el-radio>
          <el-radio :label="2">1小时一次</el-radio>
          <el-radio :label="3">2小时一次</el-radio>
          <el-radio :label="4">4小时一次</el-radio>
          <el-radio :label="5">6小时一次</el-radio>
          <el-radio :label="6">8小时一次</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item
        label="弹窗位置"
        prop="popup_position"
      >
        <el-checkbox-group v-model="ruleForm.popup_position">
          <el-checkbox-group v-model="ruleForm.popup_position">
            <el-checkbox
              v-for="date in dates"
              :key="date.key"
              :label="date.key"
            >{{ date.label }}</el-checkbox>
          </el-checkbox-group>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="用户范围">
        <el-radio-group v-model="ruleForm.user_type">
          <el-radio :label="0">全部</el-radio>
          <!-- <el-radio :label="1">充值用户</el-radio>
          <el-radio :label="2">未充值用户</el-radio> -->
        </el-radio-group>
      </el-form-item>

      <el-form-item label="期限选择">
        <el-select
          v-model="time_type"
          placeholder="请选择"
        >
          <el-option
            v-for="item in timeoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="time_type === 2"
        label="固定天数"
        prop="appoint_day"
      >
        <el-input
          v-model="ruleForm.appoint_day"
          style="width:300px"
          placeholder="请输入固定天数"
          type="number"
          :onkeyup="ruleForm.appoint_day = ruleForm.appoint_day.replace(/[^A-z0-9]/, '')"
        />
      </el-form-item>
      <el-form-item
        v-if="time_type === 1"
        label="活动时间"
        prop="timearr"
      >
        <el-date-picker
          v-model="ruleForm.timearr"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width:410px"
          :picker-options="pickerOptions"
          :clearable="false"
          @change="datavalue"
        />
      </el-form-item>

      <el-form-item
        label="选择模板"
        prop="theme_id"
      >
        <el-tag
          v-if="ruleForm.theme_id !== null"
          size="medium"
          style="height:35px;line-height:35px;margin-right:10px;padding: 0 23px;"
        >{{ temp_id_name }}</el-tag>
        <el-button
          type="primary"
          @click="choosetheme(1)"
        >选择活动主题 </el-button>
      </el-form-item>
      <el-form-item
        label="选择阅读页"
        prop="banner_img_url"
      >
        <div>
          <img
            v-if="ruleForm.banner_img_url!=''"
            style="width: 30%;height: 30%;"
            :src="ruleForm.banner_img_url"
            alt=""
          >
        </div>
        <el-button
          type="primary"
          @click="choosetheme(2)"
        >选择阅读页 </el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          style="margin-top:10px"
          type="primary"
          @click="submitForm('ruleForm')"
        >立即创建</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="活动主题选择"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <duothemedialog
        ref="themeview"
        @close="close"
        @closetwo="closetwo"
      />
    </el-dialog>
  </div>
</template>

<script>
import { acawraccountlist, readingservice } from '@/api/sourceMaterial.js'
import duothemedialog from './duothemedialog.vue'
export default {
  components: {
    duothemedialog
  },
  props: {
    platformid: {
      type: Number,
      default: null
    }
  },
  data() {
    var checkAgetwo = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.appoint_day.length > 3) {
        callback(new Error('不能超过3位'))
      } else {
        callback()
      }
    }
    var checkAge = (rule, value, callback) => {
      console.log(this.ruleForm.timearr[0])
      console.log(this.ruleForm.timearr[1])
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.timearr[0] == this.ruleForm.timearr[1]) {
        callback(new Error('不能选择相同的时间'))
      } else {
        callback()
      }
    }
    return {
      // eslint-disable-next-line no-misleading-character-class
      reg: /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi,
      ruleForm: {
        title: '',
        recharge_money: '',
        coin: '',
        give_coin: '',
        recharge_times: '',
        timearr: [],
        theme_id: null,
        popup_rule: 1,
        popup_position: [],
        user_type: 0,
        banner_img_url: '',
        appoint_day: ''
      },
      activeytype: null,
      time_type: 2,
      dates: [
        {
          key: 1,
          label: '小说首页'
        },
        {
          key: 2,
          label: '短剧首页'
        },
        {
          key: 3,
          label: '书架(收藏)'
        },
        {
          key: 4,
          label: '分类'
        },
        {
          key: 5,
          label: '阅读页'
        },
        {
          key: 6,
          label: '充值返回'
        }
      ],
      pickerOptions: {
        // 禁用当前日期之前的日期
        disabledDate(time) {
          // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      start_time: '', // 开始时间
      end_time: '', // 结束时间
      temp_id_name: '', // 模板名称
      theme: [],
      banners: [],
      timeoptions: [
        {
          value: 1,
          label: '指定期限'
        },
        {
          value: 2,
          label: '固定天数'
        }
      ],
      restrictions: [],
      dialogVisible: false,
      options: [
        {
          value: 1,
          label: '充值金额'
        },
        {
          value: 2,
          label: '年费会员'
        },
        {
          value: 3,
          label: '免费赠币'
        }
      ],
      rules: {
        title: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
        recharge_money: [{ required: true, message: '请输入充值金额', trigger: 'blur' }],
        // coin: [{ required: true, message: '请输入金币数量', trigger: 'blur' }],
        give_coin: [{ required: true, message: '请输入赠送金币', trigger: 'blur' }],
        recharge_times: [{ required: true, message: '请选择充值次数', trigger: 'change' }],
        timearr: [
          { type: 'array', required: true, message: '请选择时间', trigger: 'change' },
          { validator: checkAge, trigger: 'change' }
        ],
        appoint_day: [
          { required: true, message: '请输入固定天数', trigger: 'change' },
          { validator: checkAgetwo, trigger: 'change' }
        ],
        popup_position: [{ type: 'array', required: true, message: '请至少选择一个位置', trigger: 'change' }],
        theme_id: [{ required: true, message: '请选择活动模板', trigger: 'change' }],
        banner_img_url: [{ required: true, message: '请选择阅读页', trigger: 'change' }]
      }
    }
  },
  computed: {
    cionnum() {
      return Number(this.ruleForm.recharge_money) * 100
    }
  },
  created() {
    this.getlistr()
    this.init()
  },
  mounted() {},
  methods: {
    init() {
      this.restrictions = []
      for (let i = 1; i <= 20; i++) {
        this.restrictions.push({
          value: i,
          label: `${i}次`
        })
        if (i === 20) {
          this.restrictions.push({
            value: 9999,
            label: `无限次`
          })
        }
      }
    },
    async getlistr() {
      const data = await acawraccountlist({
        platformId: this.platformid,
        activityType: 1
      })
      console.log(data.data)
      this.theme = data.data.theme
      this.banners = data.data.banners
    },
    activechange(val) {
      console.log('val', val)
      // eslint-disable-next-line eqeqeq
      if (val == 2) {
        console.log('第二个')
        this.ruleForm.coin = ''
      }
      // eslint-disable-next-line eqeqeq
      if (val == 3) {
        console.log('第三个')
        this.ruleForm.recharge_times = 1
        this.ruleForm.recharge_money = ''
      }
      this.getlistr()
    },
    choosetheme(type) {
      this.dialogVisible = true
      if (type === 1) {
        this.$nextTick(() => {
          this.$refs.themeview.send(this.theme, type)
        })
      } else {
        this.$nextTick(() => {
          this.$refs.themeview.send(this.banners, type)
        })
      }
    },
    close(item) {
      this.dialogVisible = false
      this.ruleForm.theme_id = item.id
      this.temp_id_name = item.title
      console.log('item', item)
    },
    closetwo(item) {
      this.dialogVisible = false
      this.ruleForm.banner_img_url = item
      console.log('item', item)
    },
    activemoney() {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.recharge_money <= 0 && this.ruleForm.recharge_money != '') {
        this.ruleForm.recharge_money = 1
      }
    },
    activegivemoney() {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.coin <= 0 && this.ruleForm.coin != '') {
        this.ruleForm.coin = 1
      }
    },
    givemoneyuwrw() {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.give_coin <= 0 && this.ruleForm.give_coin != '') {
        this.ruleForm.give_coin = 1
      }
    },
    datavalue(val) {
      console.log('val', val)
      this.start_time = val[0]
      this.end_time = val[1]
    },
    popupser(val) {
      console.log(val)
      // eslint-disable-next-line eqeqeq
      // if (val == 0) {
      //   this.ruleForm.popup_position = []
      // }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const par = {}
          if (this.time_type === 1) {
            par.time_type = this.time_type
            par.start_time = this.start_time
            par.end_time = this.end_time
          } else {
            par.time_type = this.time_type
            par.appoint_day = Number(this.ruleForm.appoint_day)
          }
          console.log('this.activeytype', this.activeytype, this.ruleForm.popup_position.toString())
          readingservice({
            platform_id: this.platformid,
            activity_type: 1,
            ...par,
            activity_info: {
              title: this.ruleForm.title,
              recharge_money: this.ruleForm.recharge_money,
              coin: Number(this.ruleForm.recharge_money) * 100,
              give_coin: this.ruleForm.give_coin,
              recharge_times: this.ruleForm.recharge_times,
              popup_position: this.ruleForm.popup_position.toString(),
              popup_rule: this.ruleForm.popup_rule,
              user_type: this.ruleForm.user_type,
              // start_time: this.start_time,
              // end_time: this.end_time,
              theme_id: this.ruleForm.theme_id,
              banner_img_url: this.ruleForm.banner_img_url
            }
          }).then(res => {
            this.$message({
              type: 'success',
              message: '添加成功!'
            })
            this.$emit('close')
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
/**
 * 解决el-input设置类型为number时，中文输入法光标上移问题
 **/
.demo-ruleForm /deep/ .el-input__inner {
  line-height: 1px !important;
}

/**
 * 解决el-input设置类型为number时，去掉输入框后面上下箭头
 **/
.demo-ruleForm /deep/ input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
